import React from 'react';
export function About() {
  return <section id="about" className="py-20 bg-white border-b border-gray-100" data-id="element-33">
      <div className="container mx-auto px-4" data-id="element-34">
        <div className="text-center mb-16" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-36">
            Why Swedenmark AI
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full" data-id="element-37"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-start" data-id="element-38">
          <div className="space-y-8" data-id="element-39">
            <div data-id="element-40">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-41">
                We don't sell projects.{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500" data-id="element-42">
                  We sell outcomes.
                </span>
              </h3>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-43">
                Most AI consultants bill for hours and hand over a report. We
                measure ourselves against the numbers your business actually
                runs on — tickets resolved, meetings booked, leads reactivated,
                hours reclaimed. If those numbers don't move, neither does the
                engagement.
              </p>
            </div>

            <p className="text-gray-600 text-lg leading-relaxed" data-id="element-44">
              That's why we embed alongside your team instead of orbiting it. We
              learn how the work really happens, ship systems that hold up under
              real conditions, and stay close enough to keep them improving long
              after launch.
            </p>

            <div className="grid sm:grid-cols-3 gap-4 pt-2" data-id="element-45">
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-4" data-id="element-46">
                <div className="text-xs font-semibold uppercase tracking-wider text-blue-600 mb-1" data-id="element-47">
                  Embedded
                </div>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-48">
                  We work inside your operation, not from a distance
                </p>
              </div>
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-4" data-id="element-49">
                <div className="text-xs font-semibold uppercase tracking-wider text-blue-600 mb-1" data-id="element-50">
                  Measured
                </div>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-51">
                  Tied to the metrics your business already tracks
                </p>
              </div>
              <div className="bg-gray-50 border border-gray-100 rounded-lg p-4" data-id="element-52">
                <div className="text-xs font-semibold uppercase tracking-wider text-purple-600 mb-1" data-id="element-53">
                  Accountable
                </div>
                <p className="text-sm text-gray-600 leading-snug" data-id="element-54">
                  We own outcomes, not just deliverables
                </p>
              </div>
            </div>

            <div className="border-l-4 border-l-blue-500 pl-6 py-2 bg-gradient-to-r from-blue-50/50 to-purple-50/50 rounded-r-lg" data-id="element-55">
              <blockquote className="text-xl font-medium text-gray-900 italic" data-id="element-56">
                "Built for companies ready to move from AI curiosity to AI
                advantage."
              </blockquote>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-57">
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" data-id="element-58">
              <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Analytics dashboard with performance metrics" className="w-full h-full object-cover" data-id="element-59" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mt-8" data-id="element-60">
              <img src="https://images.unsplash.com/photo-1531297484001-80022131f5a1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sleek automation workspace" className="w-full h-full object-cover" data-id="element-61" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden" data-id="element-62">
              <img src="https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Abstract data and automation patterns" className="w-full h-full object-cover" data-id="element-63" />
            </div>
            <div className="aspect-square bg-gray-100 rounded-lg overflow-hidden mt-8" data-id="element-64">
              <img src="https://images.unsplash.com/photo-1518186285589-2f7649de83e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Sleek automation and modern technology" className="w-full h-full object-cover" data-id="element-65" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}